webpackJsonp([263791100135453],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _styledComponents2.default.button.withConfig({
	  displayName: 'Button',
	  componentId: 'w0oprv-0'
	})(['height:42px;line-height:42px;font-size:15px;font-weight:700;border-radius:42px;box-shadow:0 0 6px 0 rgba(0,0,0,0.15);background-color:white;color:', ';padding:0 23px;margin:10px 10px 10px 0;transition:all .25s ease;& i{margin-right:10px;}&:last-child{margin-right:0;}&:hover,&:active{box-shadow:0 0 6px 0 rgba(0,0,0,0.2);background-color:', ';color:white;}&:disabled{cursor:default;box-shadow:none;background-color:', ';color:white;&:hover,&:active{box-shadow:none;background-color:', ';color:white;}}@media (max-width:900px){height:35px;line-height:35px;}', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ''], function (props) {
	  return props.gray ? _styles.colors.mainGray : props.red ? _styles.colors.mainRed : _styles.colors.mainBlue;
	}, function (props) {
	  return props.gray ? _styles.colors.mainGray : props.red ? _styles.colors.mainRed : _styles.colors.mainBlue;
	}, function (props) {
	  return _styles.colors.lightGray;
	}, function (props) {
	  return _styles.colors.lightGray;
	}, function (props) {
	  return props.small ? '\n      min-width: 90px;\n      height: 30px;\n      line-height: 30px;\n      font-size: 12px;\n  ' : '';
	}, function (props) {
	  return props.light ? '\n    background-color: ' + (props.gray ? _styles.colors.lightGray : props.red ? _styles.colors.mainRed : _styles.colors.mainBlue) + ';\n    color: white;\n    ' + (props.gray ? 'box-shadow: none;' : '') + '\n\n    &:hover, &:active {\n      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);\n      color: ' + (props.gray ? _styles.colors.mainGray : props.red ? _styles.colors.mainRed : _styles.colors.mainBlue) + ';\n      background-color: white;\n    }\n  ' : '';
	}, function (props) {
	  return props.fullHeight || props.clipboard ? '\n    background-color: ' + _styles.colors.mainBlue + ';\n    color: white;\n    margin: 0;\n\n    &:hover, &:active {\n      background-color: ' + _styles.colors.darkBlue + ';\n    }\n  ' : '';
	}, function (props) {
	  return props.fullWidth ? '\n    display: block;\n    width: 100%;\n    margin: 20px 0;\n  ' : '';
	}, function (props) {
	  return props.fullHeight ? '\n    height: 100%;\n    line-height: 100%;\n    border-radius: 0;\n    padding: 0 40px;\n\n    @media (max-width: 900px) {\n      height: 100%;\n    }\n  ' : '';
	}, function (props) {
	  return props.clipboard ? '\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.28);\n    height: 44px;\n    line-height: 44px;\n    padding: 0 16px;\n    border-radius: 0 4px 4px 0;\n  ' : '';
	}, function (props) {
	  return props.underline ? '\n    position: relative;\n    height: 30px;\n    font-size: 20px;\n    line-height: 25px;\n    background-color: transparent;\n    color: ' + _styles.colors.darkGray + ';\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n    border-bottom: 5px solid ' + (props.gray ? _styles.colors.mainGray : _styles.colors.mainBlue) + ';\n\n    &:hover, &:active {\n      background-color: transparent;\n      color: ' + _styles.colors.darkGray + ';\n      box-shadow: none;\n    }\n  ' : '';
	}, function (props) {
	  return props.plain ? '\n    height: 30px;\n    font-size: 20px;\n    line-height: 30px;\n    background: transparent;\n    padding: 0;\n    box-shadow: none;\n    color: ' + _styles.colors.darkGray + ';\n\n    &:hover, &:active {\n      background: transparent;\n      box-shadow: none;\n      color: ' + _styles.colors.darkGray + ';\n    }\n\n    &:disabled {\n      background: transparent;\n      color: ' + _styles.colors.darkGray + ';\n      opacity: .5;\n\n      &:hover, &:active {\n        box-shadow: none;\n        background: transparent;\n        color: ' + _styles.colors.darkGray + ';\n      }\n    }\n  ' : '';
	}, function (props) {
	  return props.fullHeight && props.fullWidth ? '\n    margin: 0px;\n  ' : '';
	}, function (props) {
	  return props.css || '';
	});
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/amelie.4413aa74.png";

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/arslan.072f5f7a.png";

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/candy.2414262e.png";

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/desiree.768db17a.png";

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/edmond.bf0a2acf.png";

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kurt.67f7ee96.png";

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/marco.00d1b983.png";

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ron.644ac474.png";

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Button = __webpack_require__(155);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _header = __webpack_require__(20);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _edmond = __webpack_require__(571);
	
	var _edmond2 = _interopRequireDefault(_edmond);
	
	var _marco = __webpack_require__(573);
	
	var _marco2 = _interopRequireDefault(_marco);
	
	var _candy = __webpack_require__(569);
	
	var _candy2 = _interopRequireDefault(_candy);
	
	var _arslan = __webpack_require__(568);
	
	var _arslan2 = _interopRequireDefault(_arslan);
	
	var _amelie = __webpack_require__(567);
	
	var _amelie2 = _interopRequireDefault(_amelie);
	
	var _desiree = __webpack_require__(570);
	
	var _desiree2 = _interopRequireDefault(_desiree);
	
	var _kurt = __webpack_require__(572);
	
	var _kurt2 = _interopRequireDefault(_kurt);
	
	var _ron = __webpack_require__(574);
	
	var _ron2 = _interopRequireDefault(_ron);
	
	var _i18n = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var t = (0, _i18n.translate)('pages/about');
	
	var AboutPageDiv = _styledComponents2.default.div.withConfig({
	  displayName: 'about__AboutPageDiv',
	  componentId: 'o1e1kv-0'
	})(['min-height:200px;padding:158px 35px 50px;.col-left{flex:0 0 299px;}.col-left div.title{width:204px;font-size:25px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.28;letter-spacing:normal;text-align:left;color:#2f2e2e;}.col-right{padding-left:30px;}.col-right div.wrap-description{width:675px;font-size:24px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.46;letter-spacing:normal;text-align:left;color:#2f2e2e;}.col-right div.wrap-description .paragraph:not(:first-child){padding-top:40px;}@media (max-width:900px){padding:108px 15px 50px;flex-direction:column;.col-left{flex:0 0 100%;margin-bottom:20px;}.col-left div.title{width:100%;font-size:20px;}.col-right{padding-left:0;}.col-right div.wrap-description{width:100%;font-size:19px;}}']);
	
	var DivAboutJuven = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivAboutJuven',
	  componentId: 'o1e1kv-1'
	})(['display:flex;.col-left{font-size:35px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.4;text-align:left;}.description{width:678px;font-size:35px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.4;letter-spacing:normal;text-align:left;color:#2f2e2e;}.join-us{font-size:35px;font-weight:bold;padding-top:10px;display:inline-block;border-bottom:7px solid #00a7ff;cursor:pointer;}a{line-height:35px;}@media (max-width:900px){flex-direction:column;.description{width:100%;}.col-left,.description,.join-us{font-size:25px;}}']);
	
	var slide_animation = (0, _styledComponents.keyframes)(['100%{transform:translateX(-100%);}']);
	
	var DivImages = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivImages',
	  componentId: 'o1e1kv-2'
	})(['margin:120px -35px 58px -35px;display:block;overflow:hidden;white-space:nowrap;.img-item{width:368px;height:572px;display:inline-block;}.img-item img{width:100%;height:100%;object-fit:cover;}.slideshow{animation:', ' 36s linear infinite;width:2944px;height:400px;position:relative;}'], slide_animation);
	
	var DivWhatSeemDoing = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivWhatSeemDoing',
	  componentId: 'o1e1kv-3'
	})(['display:flex;@media (max-width:900px){flex-direction:column;}']);
	
	var DivWhatActuallyDoing = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivWhatActuallyDoing',
	  componentId: 'o1e1kv-4'
	})(['display:flex;margin-top:68px;@media (max-width:900px){flex-direction:column;}']);
	
	var DivWhereWeWantToGo = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivWhereWeWantToGo',
	  componentId: 'o1e1kv-5'
	})(['display:flex;margin-top:68px;.wrap-description .title{font-size:35px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.26;letter-spacing:normal;text-align:left;color:#2f2e2e;}@media (max-width:900px){flex-direction:column;.wrap-description .title{font-size:25px;}}']);
	
	var DivWhatValueMost = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivWhatValueMost',
	  componentId: 'o1e1kv-6'
	})(['display:flex;margin-top:68px;@media (max-width:900px){flex-direction:column;}']);
	
	var DivJuvenStandard = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivJuvenStandard',
	  componentId: 'o1e1kv-7'
	})(['display:flex;margin-top:68px;@media (max-width:900px){flex-direction:column;}']);
	
	var DivJoinUs = _styledComponents2.default.div.withConfig({
	  displayName: 'about__DivJoinUs',
	  componentId: 'o1e1kv-8'
	})(['display:flex;flex-direction:column;text-align:center;margin-top:68px;margin-bottom:30px;.title{font-size:35px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.26;letter-spacing:normal;color:#2f2e2e;}.btnGroup{margin-top:30px;}.btn-joinus{padding:0 50px;}@media (max-width:900px){flex-direction:column;.title{font-size:25px;}}']);
	
	var JoinUsButton = (0, _styledComponents2.default)(_Button2.default).withConfig({
	  displayName: 'about__JoinUsButton',
	  componentId: 'o1e1kv-9'
	})(['border-radius:50px;padding:15px 50px;']);
	
	var AboutJuven = _react2.default.createElement(
	  DivAboutJuven,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'col-left' },
	    _react2.default.createElement(
	      'div',
	      null,
	      'ABOUT JUVEN'
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'col-right' },
	    _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      t('Impact and Quality'),
	      _react2.default.createElement('br', null),
	      t('Leadership and Teamwork'),
	      _react2.default.createElement('br', null),
	      t('Creativity and Flexibility'),
	      _react2.default.createElement('br', null),
	      t('Discipline and Integrity')
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '/careers' },
	      _react2.default.createElement(
	        'div',
	        { className: 'join-us' },
	        t('JOIN US')
	      )
	    )
	  )
	);
	
	var memberImages = [{
	  url: _edmond2.default
	}, {
	  url: _marco2.default
	}, {
	  url: _candy2.default
	}, {
	  url: _arslan2.default
	}, {
	  url: _amelie2.default
	}, {
	  url: _desiree2.default
	}, {
	  url: _kurt2.default
	}, {
	  url: _ron2.default
	}];
	var Images = _react2.default.createElement(
	  DivImages,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'slideshow' },
	    memberImages.map(function (item, i) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'img-item', key: i },
	        _react2.default.createElement('img', { src: item.url })
	      );
	    }),
	    memberImages.map(function (item, i) {
	      if (i > 5) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'img-item', key: i },
	        _react2.default.createElement('img', { src: item.url })
	      );
	    })
	  )
	);
	var WhatSeemDoing = _react2.default.createElement(
	  DivWhatSeemDoing,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'col-left' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      t('WHAT WE SEEM TO BE DOING')
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'col-right' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap-description' },
	      t('We provide a multi-platform ticketing and events software that is unique, refreshing and, most interestingly, charges nothing for any transactions made. We create powerful and intuitive software tools for managing communities, events and payments.')
	    )
	  )
	);
	
	var WhatActuallyDoing = _react2.default.createElement(
	  DivWhatActuallyDoing,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'col-left' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      t('WHAT WE ARE ACTUALLY DOING')
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'col-right' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap-description' },
	      _react2.default.createElement(
	        'div',
	        { className: 'paragraph' },
	        t('Juven builds and empowers the membership ecosystem for organizations of all types and sizes through technology and design. Here, idea exchange is seamless and intuitive, transactions fast and cost-effective, and engagement easy and creative.')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'paragraph' },
	        t('Each of us at Juven plays a distinctive role. Our software engineers build beautifully designed products with the latest technology. Our designers shape perspectives and behaviors that people have towards organizational engagement. Our business team spreads our vision far and wide, building what is to become a wonderful success story.')
	      )
	    )
	  )
	);
	
	var WhereWeWantToGo = _react2.default.createElement(
	  DivWhereWeWantToGo,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'col-left' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      t('WHERE WE WANT TO GO')
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'col-right' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap-description' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        t('“We aspire to build the golden standard of organizational engagement.”')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'paragraph' },
	        t('We want to be the top company in organisational community development, like McKinsey in consulting, or Goldman Sachs in finance. In fact, senior executives in these firms have invested in us. With our passion, technical expertise and our commitment to quality, we pride ourselves on building partnerships with different organisations and delivering impact.')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'paragraph' },
	        t('There are countless organizations building wonderful communities across the globe. We are here to be their technology partner.')
	      )
	    )
	  )
	);
	
	var JuvenStandard = _react2.default.createElement(
	  DivJuvenStandard,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'col-left' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      t('THE JUVEN STANDARD')
	    )
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'col-right' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap-description' },
	      _react2.default.createElement(
	        'div',
	        { className: 'paragraph' },
	        t('Juven is impact driven. Juven stands for maintaining professional excellence while remaining agile, responsive and dynamic in a fast-moving industry. We stand for daring to fail, and growing and evolving through to success.')
	      )
	    )
	  )
	);
	
	var JoinUs = _react2.default.createElement(
	  DivJoinUs,
	  null,
	  _react2.default.createElement(
	    'div',
	    { className: 'title' },
	    t('We Are Recruiting')
	  ),
	  _react2.default.createElement(
	    'div',
	    { className: 'btnGroup' },
	    _react2.default.createElement(
	      'a',
	      { href: '/careers' },
	      _react2.default.createElement(
	        JoinUsButton,
	        { fullHeight: true },
	        t('JOIN US')
	      )
	    )
	  )
	);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: t('About | Juven') }),
	    _react2.default.createElement(_header2.default, { showLanguage: true, noScroll: true }),
	    _react2.default.createElement(
	      AboutPageDiv,
	      null,
	      AboutJuven,
	      Images,
	      WhatSeemDoing,
	      WhatActuallyDoing,
	      WhereWeWantToGo,
	      JuvenStandard,
	      JoinUs
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-65882895078cbfac43f5.js